(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reveal on scroll
  var items = document.querySelectorAll('[data-iw-reveal]');
  if (!reduce && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('iw-anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  // Ticker pause
  document.querySelectorAll('[data-iw-ticker-toggle]').forEach(function (btn) {
    var band = btn.closest('.iw-ticker');
    if (reduce) band.classList.add('is-paused');
    var sync = function () {
      var paused = band.classList.contains('is-paused');
      btn.textContent = paused ? btn.dataset.play : btn.dataset.pause;
    };
    sync();
    btn.addEventListener('click', function () { band.classList.toggle('is-paused'); sync(); });
  });

  // Routine builder
  document.querySelectorAll('[data-iw-finder]').forEach(function (root) {
    var panels = root.querySelectorAll('[data-iw-panel]');
    root.querySelectorAll('input[type=radio]').forEach(function (r) {
      r.addEventListener('change', function () {
        panels.forEach(function (p) { p.hidden = p.dataset.iwPanel !== r.value; });
      });
    });
    var status = root.querySelector('[data-iw-status]');
    root.querySelectorAll('[data-iw-add-all]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var ids = (btn.dataset.ids || '').split(',').filter(Boolean);
        if (!ids.length) return;
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        fetch(root.dataset.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = root.dataset.cartUrl;
        }).catch(function () {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          status.textContent = '';
          requestAnimationFrame(function () { status.textContent = root.dataset.error; });
        });
      });
    });
  });

  // Sticky add to cart
  var bar = document.querySelector('[data-iw-sticky]');
  var form = document.querySelector('.product-form__buttons');
  var submit = document.querySelector('.product-form__submit');
  if (bar && form && submit && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-on', show);
      bar.inert = !show;
    }).observe(form);
    bar.querySelector('button').addEventListener('click', function () {
      if (submit.disabled) { form.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); return; }
      submit.click();
    });
  }
})();
